/**
 * Zendesk module - Removed for static content site
 * These are no-op stubs to maintain API compatibility
 */

export const setup = () => {}
export const hideWidget = () => {}
export const showWidget = () => {}
export const openChat = () => {}
export const closeChat = () => {}
export const getChatStatus = () => false
export const resetChatStatus = () => {}
